export const BRAND_NAME = "FastRecovery App/Web";
export const BRAND_DISPLAY_NAME = "Fast Recovery";
export const COMPANY_LEGAL_NAME = "Software Solutions Development India";
export const SUPPORT_EMAIL = "fastrecovery26@gmail.com , admin@ssdi.co.in";
export const ADMIN_PANEL_TITLE = `${BRAND_NAME} Admin`;
